import { render, staticRenderFns } from "./RewardActions.vue?vue&type=template&id=4bf51b74"
import script from "./RewardActions.vue?vue&type=script&lang=js"
export * from "./RewardActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports